import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import api from './api';

const f = (key, label, def, multiline = false) => ({ key, label, def, multiline });
const services = (prefix, list) => list.flatMap(([title, desc], i) => [
  f(`${prefix}.s${i + 1}.title`, `Service 0${i + 1} — titre`, title),
  f(`${prefix}.s${i + 1}.desc`, `Service 0${i + 1} — description`, desc, true),
]);

export const CONTENT_GROUPS = [
  { title: 'Accueil et page La Maison — Présentation', fields: [
    f('maison.label', 'Surtitre', 'La Maison JBMH'),
    f('maison.headline', 'Titre (retour à la ligne = nouvelle ligne)', 'Deux regards.\nUne même exigence.', true),
    f('maison.paragraph', 'Paragraphe', 'JBMH Events est une maison de conception, de scénographie et d’organisation événementielle. Nous imaginons des expériences sur mesure, pensées autour d’une intention, d’un lieu et de ce que vous souhaitez faire vivre à vos invités.', true),
    f('maison.cta', 'Lien', 'Découvrir la maison'),
  ] },
  { title: 'Accueil — Trois univers', fields: [
    f('univers.label', 'Surtitre', 'Une maison'),
    f('univers.headline', 'Titre', 'Trois univers.'),
    f('univers.weddings.title', '01 — titre', 'Weddings'),
    f('univers.weddings.desc', '01 — description', 'Des célébrations pensées dans leur intégralité, où chaque choix révèle votre histoire.', true),
    f('univers.receptions-corporate.title', '02 — titre', 'Réceptions privées & Corporate'),
    f('univers.receptions-corporate.desc', '02 — description', 'Des expériences conçues pour recevoir, rassembler et marquer les esprits.', true),
    f('univers.heritage.title', '03 — titre', 'JBMH Héritage'),
    f('univers.heritage.desc', '03 — description', 'Les traditions révélées avec élégance, dans le respect de chaque histoire.', true),
  ] },
  { title: 'Accueil — Réalisations', fields: [
    f('real.label', 'Surtitre', 'Réalisations'),
    f('real.headline', 'Titre', 'Des histoires mises en scène.'),
    f('real.intro', 'Introduction', 'Une sélection de projets où le lieu, la matière, la lumière et l’émotion composent un langage singulier.', true),
    f('real.cat.weddings', 'Catégorie 1', 'Weddings'),
    f('real.cat.receptions', 'Catégorie 2', 'Réceptions privées'),
    f('real.cat.heritage', 'Catégorie 3', 'JBMH Héritage'),
    f('real.cat.corporate', 'Catégorie 4', 'Corporate'),
    f('real.cta', 'Lien', 'Découvrir toutes les réalisations'),
  ] },
  { title: 'La Maison — Notre histoire', fields: [
    f('histoire.label', 'Surtitre', 'Notre histoire'),
    f('histoire.headline', 'Titre', 'Une sensibilité commune,\ndeux regards complémentaires.', true),
    f('histoire.story', 'Histoire des fondateurs', 'Derrière JBMH Events, il y a Mamadu et Halima. Nos parcours en architecture et en travail social réunissent une lecture précise des espaces et une écoute attentive des personnes. Cette complémentarité nous permet de faire dialoguer le lieu, l’esthétique, l’organisation et l’expérience vécue.', true),
    f('histoire.quote', 'Citation', '« Comprendre avant d’imaginer. Concevoir avant de produire. Orchestrer avec précision. »', true),
    f('histoire.v1.title', 'Valeur 01 — titre', 'Écoute'), f('histoire.v1.desc', 'Valeur 01 — texte', 'Comprendre l’histoire, les attentes et l’intention.'),
    f('histoire.v2.title', 'Valeur 02 — titre', 'Beauté'), f('histoire.v2.desc', 'Valeur 02 — texte', 'Composer avec mesure, émotion et caractère.'),
    f('histoire.v3.title', 'Valeur 03 — titre', 'Maîtrise'), f('histoire.v3.desc', 'Valeur 03 — texte', 'Anticiper et conduire chaque étape avec précision.'),
    f('histoire.v4.title', 'Valeur 04 — titre', 'Harmonie'), f('histoire.v4.desc', 'Valeur 04 — texte', 'Unir le lieu, l’esthétique et l’expérience.'),
  ] },
  { title: 'Page Weddings', fields: [
    f('weddings.label', 'Surtitre', 'Univers 01 — Weddings'),
    f('weddings.headline', 'Titre', 'Des célébrations pensées\ndans leur intégralité.', true),
    ...services('weddings', [
      ['Conception & direction artistique', 'Intention, palette, matières et langage visuel.'],
      ['Planification', 'Calendrier, budget, échéances et déroulement.'],
      ['Lieux & prestataires', 'Recherche, sélection et coordination.'],
      ['Scénographie & décoration', 'Floraux, tables, lumière, mobilier et papeterie.'],
      ['Coordination du jour J', 'Installation, prestataires et temps forts.'],
      ['Destination Wedding', 'Europe et international.'],
    ]),
  ] },
  { title: 'Page Réceptions privées & Corporate', fields: [
    f('receptions.label', 'Surtitre', 'Univers 02 — Réceptions privées & Corporate'),
    f('receptions.headline', 'Titre', 'Recevoir est un art.'),
    f('receptions.intro', 'Introduction', 'Dîner privé, gala, réception d’entreprise ou événement de marque : chaque occasion mérite une atmosphère pensée avec intention et une organisation parfaitement maîtrisée.', true),
    ...services('receptions', [
      ['Dîners privés', 'Tables signature et expériences culinaires.'],
      ['Galas & réceptions', 'Accueillir, remercier et célébrer.'],
      ['Événements d’entreprise', 'Rencontres, remises de prix et soirées.'],
      ['Événements de marque', 'Lancements, presse et activations.'],
      ['Production', 'Scénographie, lumière et coordination technique.'],
      ['Coordination', 'Déroulement, prestataires et invités.'],
    ]),
  ] },
  { title: 'Page JBMH Héritage', fields: [
    f('heritage.label', 'Surtitre', 'Univers 03 — JBMH Héritage'),
    f('heritage.headline', 'Titre', 'Honorer l’héritage,\ncélébrer le présent.', true),
    f('heritage.intro', 'Introduction', 'JBMH Héritage est l’univers de la Maison consacré aux Henna Time et aux célébrations traditionnelles. Nous mettons en valeur les gestes, les symboles et les coutumes propres à chaque famille, à travers une lecture actuelle et profondément respectueuse.', true),
    f('heritage.quote', 'Citation', '« Une tradition demeure vivante lorsqu’elle est transmise, célébrée et réinterprétée avec respect. »', true),
    ...services('heritage', [
      ['Henna Time', 'Scénographie, assises, tables basses et textiles.'],
      ['Réceptions traditionnelles', 'Célébrations familiales et culturelles.'],
      ['Coin d’honneur', 'Un espace central pensé comme une signature.'],
      ['Personnalisation', 'Objets, motifs et références familiales.'],
    ]),
  ] },
  { title: 'Accueil — Témoignages & partenaires', fields: [
    f('testimonials.label', 'Témoignages — surtitre', 'Témoignages'),
    f('testimonials.title', 'Témoignages — titre', 'Mots Doux'),
    f('partners.label', 'Partenaires — surtitre', 'Partenaires & prestataires'),
    f('partners.title', 'Partenaires — titre', 'Un cercle de confiance'),
  ] },
  { title: 'Page Réalisations', fields: [
    f('realpage.label', 'Surtitre', 'Réalisations'),
    f('realpage.title', 'Titre', 'Toutes les réalisations'),
    f('realpage.empty', 'Message si aucune réalisation', 'Aucune réalisation pour le moment.'),
    f('realpage.intro', 'Introduction', 'Chaque réalisation révèle une rencontre entre un lieu, une intention et une manière singulière de célébrer.\nDécouvrez une sélection de mariages, de réceptions privées, d’événements de marque et de célébrations traditionnelles conçus par la Maison.', true),
    f('realpage.filter.all', 'Filtre — tous', 'Tous les projets'),
    f('realpage.filter.weddings', 'Filtre — Weddings', 'Weddings'),
    f('realpage.filter.receptions', 'Filtre — Réceptions', 'Réceptions privées'),
    f('realpage.filter.corporate', 'Filtre — Corporate', 'Corporate & marques'),
    f('realpage.filter.heritage', 'Filtre — Héritage', 'JBMH Héritage'),
    f('realpage.project.kicker', 'Page projet — titre de l’introduction', 'Une intention, un lieu, une histoire.'),
    f('realpage.project.direction', 'Page projet — Direction artistique', 'Direction artistique'),
    f('realpage.project.palette', 'Page projet — Palette', 'Palette'),
    f('realpage.project.spaces', 'Page projet — Espaces', 'Espaces mis en scène'),
    f('realpage.project.partners', 'Page projet — Partenaires', 'Partenaires'),
    f('realpage.project.back', 'Page projet — lien retour', 'Toutes les réalisations'),
    f('realpage.project.cta', 'Page projet — lien devis', 'Demander un devis'),
  ] },
  { title: 'Page Demander un devis', fields: [
    f('devis.headline', 'Titre', 'Votre projet commence ici.'),
    f('devis.intro', 'Introduction', 'Partagez-nous les premières lignes de votre événement. Nous prendrons le temps d’en comprendre l’intention et de vous orienter vers l’accompagnement le plus adapté.', true),
  ] },
  { title: 'Page Services', fields: [
    f('services.kicker', 'Surtitre', 'Collection 2024 / 2025'),
    f('services.title1', 'Titre — ligne 1', 'Savoir'),
    f('services.title2', 'Titre — ligne 2 (italique)', '-Faire'),
    f('services.label', 'Surtitre de chaque service', 'Collection 2024'),
    f('services.cta', 'Lien de chaque service', 'Réserver ce service'),
    ...[
      ['Event Design', 'Nous sculptons l’espace et la lumière pour créer une atmosphère qui ne ressemble qu’à vous.', 'Scénographie, Art Floral, Mobilier, Lumière'],
      ['Wedding Planning', 'L’art de l’anticipation. Une gestion invisible pour une sérénité visible.', 'Gestion Budget, Sourcing, Coordination, Logistique'],
      ['Hospitality', 'Recevoir est un art. Vos invités méritent une attention de chaque instant.', 'Maîtres d’hôtel, Service FR, Accueil VIP, Sécurité'],
      ['Papeterie', 'Les premiers mots de votre histoire, imprimés sur des papiers précieux.', 'Faire-part, Menus, Signalétique, Branding'],
    ].flatMap(([title, desc, details], i) => [
      f(`services.s${i + 1}.title`, `Service 0${i + 1} — titre`, title),
      f(`services.s${i + 1}.desc`, `Service 0${i + 1} — description`, desc, true),
      f(`services.s${i + 1}.details`, `Service 0${i + 1} — détails (séparés par des virgules)`, details),
    ]),
  ] },
  { title: 'En-tête & pied de page', fields: [
    f('nav.logo', 'Logo texte de l’en-tête (si aucun logo image)', 'JBMH Events'),
    f('footer.brand', 'Nom dans le pied de page', 'JBMH EVENTS'),
    f('footer.cta', 'Bouton du pied de page', 'Démarrer un projet'),
    f('footer.zone', 'Zone (bas du pied de page)', 'Europe • International'),
  ] },
  { title: 'Page Contact', fields: [
    f('contact.headline', 'Titre', 'Votre projet commence ici.'),
    f('contact.intro1', 'Paragraphe 1', 'Vous préparez un mariage, une réception privée, un événement professionnel ou une célébration traditionnelle ? Partagez-nous les premières lignes de votre projet.', true),
    f('contact.intro2', 'Paragraphe 2', 'Nous étudierons votre demande avec attention avant de vous orienter vers l’accompagnement le plus adapté.', true),
    f('contact.zone', 'Zone d’intervention', 'Europe · International'),
  ] },
];

const DEFAULTS = Object.fromEntries(CONTENT_GROUPS.flatMap((g) => g.fields.map((x) => [x.key, x.def])));

const ContentContext = createContext({ values: {}, reload: () => {} });

export const ContentProvider = ({ children }) => {
  const [values, setValues] = useState({});
  const reload = useCallback(() => api.get('/site-content').then(({ data }) => setValues(data)).catch(() => {}), []);
  useEffect(() => { reload(); }, [reload]);
  return <ContentContext.Provider value={{ values, reload }}>{children}</ContentContext.Provider>;
};

export const useText = () => {
  const { values } = useContext(ContentContext);
  return (key) => (values[key] != null && values[key] !== '' ? values[key] : DEFAULTS[key]);
};

export const useContentReload = () => useContext(ContentContext).reload;
export const CONTENT_DEFAULTS = DEFAULTS;
